// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import { useForm } from "react-hook-form";
import useHttp from "hooks/use-http";
import { yupResolver } from "@hookform/resolvers/yup";
import useSelected from "hooks/use-selected";

// react icons
import { MdAdd } from "react-icons/md";
import { Grid, TextField, Button } from "@mui/material";

// components
import { StyledLink } from "../../components/shared/Link";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import PaginationCM from "components/shared/Pagination";
import DeleteModal from "components/shared/Modal/Delete";

// helpers
import GenarateHeadCell from "helper/generate-head-cell";
import Toast from "helper/toast";

// validation
import { NotificationSchema } from "validations";

// styled style
import { StyledStack, StyledMenuItem, StyledTitle } from "./sms.style";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { getAllUsersRequest } from "api/requests/users";
import { convertNum } from "helper/convert-num";
import { getAllSmsTemplatesRequest, sendSmsRequest } from "api/requests/sms";

const headCells = GenarateHeadCell("user_list_message");
let initialPage = 1;

export default function Sms() {
  const selectCTX = useSelected();

  // all frame state
  const [frame, setFrame] = useState({ data: [], count: 0 });

  const [selectedFrame, setSelectedFrame] = useState({ id: null, title: null });

  // all users data state
  const [users, setUsers] = useState({ data: [], count: 0 });

  const { request, loading, setLoading } = useHttp(false);

  //paginition stat
  const [page, setPage] = useState(initialPage);

  //modal state
  const [showSendModal, setshowSendModall] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(NotificationSchema),
  });

  // onOpen & onClose modal handler
  const handelShowModal = () => setshowSendModall((state) => !state);

  // handle frame select option onChange
  // const handelTempChange = (e) => {
  //   if (e === "0") {
  //     setValue("text", "");
  //   } else {
  //     setValue("text", frame.data.find((item) => item.id === e).text);
  //   }
  // };
  const handelTempChange = (e) => {
    const frameData = frame.data.find((item) => item.id === e);
    setValue("text", frameData.message);
    setSelectedFrame({ id: e, title: frameData.title });
  };

  // handle date
  const dateHandler = (value) =>
    value
      .split(" ")[0]
      // .format("YYYY-MM-DD")
      .split("-")
      .map((item) => convertNum(item))
      .join("/");

  ///////////// send message for all users /////////////
  const onSubmitAll = async (values) => {
    // values = {
    //   template_id: selectedTemplate,
    //   users: users.data.map((n) => n.id),
    // };
    // const res = await request({
    //   url: sendSmsRequest,
    //   values,
    // });
    // handelShowModal();
    // if (res) {
    //   reset({
    //     text: "",
    //     notif_template: "0",
    //     "notif-type": "message",
    //   });
    //   selectCTX.removeItems();
    //   Toast({ type: "success" });
    // }
  };

  ///////////// send sms for selected users /////////////
  const onSubmit = async (values) => {
    values = {
      template_id: selectedFrame.id,
      users: selectCTX.selectedItems,
    };
    if (showSendModal) {
      handelShowModal();
    }
    const res = await request({
      url: sendSmsRequest,
      values,
    });
    if (res) {
      reset({
        text: "",
        notif_template: "",
      });
      selectCTX.removeItems();
      Toast({ type: "success", title: "ارسال پیام" });
    }
  };

  ////////// get all frame /////////////
  const getFrame = useCallback(async () => {
    const { data: res } = await request({
      url: getAllSmsTemplatesRequest,
      values: { skip: (page - 1) * 50, limit: 50 },
      isMulty: true,
    });
    if (res) {
      let transformedData = res.map((items) => ({
        id: items.id,
        title: items.title,
        template: items.template,
        message: items.message,
      }));
      setFrame({ data: transformedData, count: res.length });
    }
  }, [page, request]);

  const handelSearch = (e) => getUsers(e);

  /////////////get users/////////////
  const getUsers = useCallback(
    async (search) => {
      setLoading(true);
      const res = await request({
        url: getAllUsersRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search: search,
        },
        isMulty: true,
      });
      await getFrame();
      if (res) {
        let transformedData = res.data.data.map((items) => ({
          id: items.id,
          full_name: items.full_name,
          phone_number: items.phone_number,
          email: items.email,
          birth_date: items.birth_date
            ? dateHandler(items.birth_date.jdate)
            : "ثبت نشده",
        }));
        setUsers({ data: transformedData, count: res.data.count });
      }
      setLoading(false);
    },
    [getFrame, page, request, setLoading]
  );

  useEffect(() => {
    getUsers();
  }, [page, getUsers]);

  useEffect(() => {
    selectCTX.removeItems();
    return () => {
      selectCTX.removeItems();
    };
  }, []);

  return (
    <DrawerCM title="ارسال پیام" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <StyledStack>
            <StyledTitle>
              ارسال پیامک
              {/* <StyledLink to="/frame/add">
                <Button endIcon={<MdAdd />} variant="contained" mt={1}>
                  افزودن قالب
                </Button>
              </StyledLink> */}
            </StyledTitle>
            <Grid container>
              {/* if notif type change later, code down is useable */}
              {/* <Grid item md={6} xs={12} p={1.5}>
                <ReactHookFormSelect
                  id="notif-type"
                  label="نحوه ارسال"
                  control={control}
                  defaultValue="sms"
                  title="نحوه ارسال"
                >
                  <StyledMenuItem value="sms">پیامک (sms)</StyledMenuItem>
                </ReactHookFormSelect>
              </Grid> */}
              <Grid item xs={12} p={1.5}>
                <ReactHookFormSelect
                  id="notif_template"
                  name="notif_template"
                  label="انتخاب قالب"
                  error={Boolean(errors.notif_template)}
                  control={control}
                  defaultValue="0"
                  title="انتخاب قالب"
                  onChange={handelTempChange}
                >
                  {frame.count === 0 && (
                    <StyledMenuItem disabled>
                      {"قالبی برای sms یافت نشد"}
                    </StyledMenuItem>
                  )}
                  {frame.data.map((row, index) => (
                    <StyledMenuItem value={row.id} key={"option" + index}>
                      {row.title}
                    </StyledMenuItem>
                  ))}
                </ReactHookFormSelect>
              </Grid>
              <Grid item xs={12} pt={3} p={1.5}>
                <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  focused
                  inputProps={{ readOnly: true }}
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helperText={errors.text?.message}
                />
              </Grid>
            </Grid>
          </StyledStack>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="انتخاب کاربران"
                rows={users.data}
                headCells={headCells}
                isSelectable
                onSubmit={handleSubmit(onSubmit)}
                onDelete={() => selectCTX.removeItems()}
                onSubmitAll={() => {
                  selectCTX.setSelectedItems(users.data.map((item) => item.id));
                  handelShowModal();
                }}
                page={page}
              />
            </Grid>

            {users.count < 1 ? (
              " "
            ) : (
              <PaginationCM
                handleChange={(e, val) => {
                  initialPage = val;
                  setPage(val);
                }}
                page={page}
                count={users.count}
              />
            )}
          </Grid>
          <DeleteModal
            show={showSendModal}
            onClose={handelShowModal}
            onDelete={handleSubmit(onSubmit)}
            title="آیا میخواهید این متن را برای همه ارسال کنید؟"
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
